/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { inject, Injectable, type Signal }                                 from "@angular/core";
import { toSignal }                                                        from "@angular/core/rxjs-interop";
import { collection, collectionData, type CollectionReference, Firestore } from "@angular/fire/firestore";
import { type GalleryItemDocument }                                        from "@bowstring/interfaces";
import { catchError, type Observable, of, switchMap }                      from "rxjs";
import { RxSsrService }                                                    from "./RxSsrService";


@Injectable({ providedIn: "root" })
export class GalleryItemsService {

  private readonly firestore: Firestore       = inject<Firestore>(Firestore);
  private readonly rxSsrService: RxSsrService = inject<RxSsrService>(RxSsrService);

  public readonly galleryItemDocuments$: Signal<Array<GalleryItemDocument> | undefined> = toSignal<Array<GalleryItemDocument> | undefined>(
    of<undefined>(undefined).pipe<Array<GalleryItemDocument> | undefined>(
      this.rxSsrService.wrap<undefined, Array<GalleryItemDocument> | undefined>(
        switchMap(
          (): Observable<Array<GalleryItemDocument> | undefined> => collectionData<GalleryItemDocument>(
            collection(
              this.firestore,
              "galleryItems",
            ) as CollectionReference<GalleryItemDocument, GalleryItemDocument>,
          ).pipe<Array<GalleryItemDocument> | undefined>(
            catchError<Array<GalleryItemDocument>, Observable<undefined>>(
              (): Observable<undefined> => of<undefined>(undefined),
            ),
          ),
        ),
        "019682ba-ec2a-75ee-af22-f293df306fae",
      ),
    ),
  );

}
